import React from 'react'
import { useDispatch } from 'react-redux'
import ActionDropdown from '@SiteComponents/ActionDropdown'

import {
  openProjectSharingPopup,
} from '@SiteModules/Popup/actions'

interface ProjectActionDropdownProps {
  readonly listActive: boolean
  readonly showDropdown: boolean
  readonly projectId: string
  readonly canManageProjectSharing: boolean
  readonly moreElementId: string
  readonly shouldAllowToAddLanguages: boolean
  readonly shouldAllowToGenerateClips: boolean
  readonly classNameForClickOutsideListenerMoreDropdown: string
  setShowDropdown(newSetShowDropdown: boolean): void
  openSetupProjectOrRenewSubscriptionPopup(projectType?: string): void
  openRenameProjectPopup(): void
  openDeleteProjectPopup(): void
  handleOpenExportationPopup(): void
}

const ProjectActionDropdown: React.FC<ProjectActionDropdownProps> = props => {
  const dispatch = useDispatch()

  const {
    listActive,
    showDropdown,
    projectId,
    canManageProjectSharing,
    moreElementId,
    shouldAllowToAddLanguages,
    shouldAllowToGenerateClips,
    classNameForClickOutsideListenerMoreDropdown,
  } = props

  const handleGenerateClips = () => {
    props.openSetupProjectOrRenewSubscriptionPopup('repurpose')
  }

  const handleAddLanguages = () => {
    props.openSetupProjectOrRenewSubscriptionPopup()
  }

  const handleShareProject = () => {
    dispatch(openProjectSharingPopup({ projectIds: [projectId], includePublicLink: false }))
    props.setShowDropdown(false)
  }

  const actionDropdownList = (
    <ul>
      {shouldAllowToGenerateClips && (
        <li
          className="ProjectsTable__action-dropdown-item"
          onClick={handleGenerateClips}
        >
          <span>✨</span>
          <span>Create clips</span>
        </li>
      )}
      {shouldAllowToAddLanguages && (
        <li
          className="ProjectsTable__action-dropdown-item"
          onClick={handleAddLanguages}
        >
          <span>＋</span>
          <span>Add languages</span>
        </li>
      )}
      {canManageProjectSharing && (
        <li
          className="ProjectsTable__action-dropdown-item"
          onClick={handleShareProject}
          data-testid="project-share-action"
        >
          <span>↗</span>
          <span>Share project</span>
        </li>
      )}
      <li
        className="ProjectsTable__action-dropdown-item"
        onClick={props.handleOpenExportationPopup}
      >
        <span>📥</span>
        <span>Export</span>
      </li>
      <li
        className="ProjectsTable__action-dropdown-item"
        onClick={props.openRenameProjectPopup}
      >
        <span>✏️</span>
        <span>Rename project</span>
      </li>
      <li
        className="ProjectsTable__action-dropdown-item"
        onClick={props.openDeleteProjectPopup}
      >
        <span>🗑️</span>
        <span>Delete project</span>
      </li>
    </ul>
  )

  return (
    <ActionDropdown
      showDropdown={showDropdown}
      dropdownList={actionDropdownList}
      classNamesForListContainer="ProjectsTable__action-dropdown"
      classNameForClickOutsideListener={classNameForClickOutsideListenerMoreDropdown}
      classNameOfScrollContainer={listActive ? 'ProjectsTableList__body' : 'ProjectsTableGrid'}
      idOfDropdownElement={moreElementId}
      idOfPortalContainer="dashboard"
      dropdownOffsetX={listActive ? 45 : 30}
      dropdownOffsetY={0}
      dropdownWidth={209} // same width as ProjectsTable__action-dropdown
      setShowDropdown={props.setShowDropdown}
    />
  )
}

export default ProjectActionDropdown
